module.exports = __webpack_public_path__ + "static/media/UpToDate.21fca621.svg";